import React, { useState } from 'react';

const TeamCard = ({ image, title, desc }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className='teamcard' 
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img src={image} alt="team-img" />
      
      {isHovered && (
        <div className='team-hover'>
          <div className="team-hover-card">
            <h3>{title}</h3>
           
           
          </div>
        </div>
      )}
    </div>
  );
};

export default TeamCard;
